// ============================================================================
// Parent route for 'Go Back' on Not Found / No Access (Design Constitution N10)
// ----------------------------------------------------------------------------
// N10's 'Go Back' goes to the parent list, not to whatever page happened to be
// in history. The parent is the nearest ancestor path the navigation owns
// (routes.ts PATH_TO_VIEW) that this user may open (the caller passes the same
// access check App uses); Home when there is none. Pure: the caller decides
// access and performs the navigation.
// ============================================================================
import {PATH_TO_VIEW} from './routes.js';

const VIEW_OF = PATH_TO_VIEW as Readonly<Record<string, string | undefined>>;

export function parentPathFor(pathname: string | null | undefined, canOpen: (view: string) => boolean): string {
  const segments = String(pathname || '')
    .split('/')
    .filter(Boolean);
  for (let n = segments.length - 1; n >= 1; n--) {
    const candidate = '/' + segments.slice(0, n).join('/');
    const view = VIEW_OF[candidate];
    if (view && canOpen(view)) return candidate;
  }
  return '/';
}
